module.exports = __webpack_public_path__ + "img/G2Lab.9cc48a7a.svg";